import { FC } from 'react';
import { withStyles } from 'vopay';
import styles from './BrandingLogo.module.scss';

const cn = withStyles(styles);

type BankLogoProps = {
  src: string;
  className?: string;
};

const BrandingLogo: FC<BankLogoProps> = ({ src, className }) => (
  <img className={cn('img', className)} width="35%" alt="Branding Logo" src={src} />
);

export default BrandingLogo;
